export default __webpack_public_path__ + "static/media/iconBath.4a2ae1f0.svg";